import { render, staticRenderFns } from "./WarehouseCreate.vue?vue&type=template&id=6fffd2e8&scoped=true&"
import script from "./WarehouseCreate.vue?vue&type=script&lang=js&"
export * from "./WarehouseCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fffd2e8",
  null
  
)

export default component.exports